import { ODSCheckbox, type ODSCheckboxProps } from '@telekom-ods/react-ui-kit';
import { type ChangeEvent, type RefObject } from 'react';

interface CheckboxProps {
  id: string;
  name: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLDivElement>) => void;
  label: string;
  disabled?: boolean;
  checked?: boolean;
  importanceRef?: RefObject<HTMLDivElement> | null;
  size?: ODSCheckboxProps['size'];
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  onChange,
  onBlur = null,
  label,
  disabled = false,
  checked = false,
  importanceRef = null,
  size = 'small',
}) => (
  <ODSCheckbox
    id={id}
    aria-label={name}
    size={size}
    label={label}
    checked={checked}
    disabled={disabled}
    onChange={onChange}
    {...(onBlur
      ? {
          onBlur: e => {
            onBlur(e);
          },
        }
      : {})}
    ref={importanceRef}
  />
);
